
import { Component, Prop, Vue } from 'bits/vue'

/**
 * Old component. Recommended to use OzBaseButton instead.
 */

@Component({})
export default class BaseButton extends Vue {
  /**
   * Insert url if button should redirect to new page
   */
  @Prop() href!: string
  /**
   * Determines if link should open in a new tab
   */
  @Prop() target!: string
  /**
   * Determines the button size
   * @values small, normal, large
   * @default normal
   */
  @Prop({ default: 'normal' }) size!: string
  /**
   * Determines the color of button
   * @values default (grey), primary
   * @default default
   */
  @Prop({ default: 'default' }) colorScheme!: 'default' | 'primary' | 'black' | 'orange' | 'purple' | 'green' | 'white'

  /**
   * Specifies the tag/element to be rendered based on href prop
   * @public
   */
  get tagName(): string {
    return this.href ? 'a' : 'button'
  }

  get role(): string | undefined {
    return this.href ? 'button' : undefined
  }
}
